import { TEntityOverride } from 'src/types'
import { TEntityUntagged } from '@obvious.tech/constellation/Entity'

const override: TEntityOverride<TEntityUntagged<'MarkerAttachment'>> = {
  global: {
    properties: {
      id: {
        displayedName: 'ID',
      },
      groups: {
        displayedName: 'Owners',
        type: 'groups',
      },
      author: {
        // field is deoprecated and awaiting removal, replaced with 'authorReference'
        hidden: true,
      },
      authorReference: {
        displayedName: 'Author',
        type: 'object',
        reference: {
          target: 'Passport',
          targetLabelKeyPath: 'username',
          idKeyPath: 'passportId',
          labelKeyPath: 'userName',
        },
      },
      markerId: {
        displayedName: 'Marker',
        reference: {
          target: 'Marker',
          targetLabelKeyPath: 'label',
        },
      },
      type: {
        displayedName: 'Type',
        type: 'enum',
        enum: ['Audio', 'Document', 'Image', 'Note', 'Video'],
      },
      data: {
        displayedName: 'Data (JSON)',
        type: 'JSONObject',
        defaultValue: {},
      },
      file: {
        // hidden because file uploads are currently not implement for this case
        // TODO: implement in `addUploadFeature` and un-hide
        hidden: true,
        displayedName: 'File',
        type: 'file',
      },
      creationDate: {
        displayedName: 'Creation Date',
      },
    },
  },
  create: {
    properties: {
      markerId: {
        readOnly: false,
      },
      creationDate: {
        hidden: true,
      },
    },
  },
}

export default override
